import ImagesIconsAuthenticating1Svg from '@/public/images/icons/authenticating/1.svg';
import ImagesIconsAuthenticating2Svg from '@/public/images/icons/authenticating/2.svg';
import ImagesIconsAuthenticating3Svg from '@/public/images/icons/authenticating/3.svg';
import ImagesIconsAuthenticating4Svg from '@/public/images/icons/authenticating/4.svg';
import ImagesIconsAuthenticatingAuthenticatingSvg from '@/public/images/icons/authenticating/authenticating.svg';

export {
  ImagesIconsAuthenticating1Svg,
  ImagesIconsAuthenticating2Svg,
  ImagesIconsAuthenticating3Svg,
  ImagesIconsAuthenticating4Svg,
  ImagesIconsAuthenticatingAuthenticatingSvg,
};
